import {createStore, applyMiddleware, compose} from 'redux'
import { persistStore, persistReducer } from 'redux-persist'
import storage from 'redux-persist/lib/storage'
import rootReducer from '../redux/reducers/rootReducer'
import thunk from 'redux-thunk'
import reduxReset from 'redux-reset'

const persistConfig = {
	key: 'root',
	storage,
	whitelist: ['auth']
}

const persistedReducer = persistReducer(persistConfig, rootReducer)

export default () => {
	let store = createStore(
		persistedReducer,
		window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
		compose(
			reduxReset(),
			applyMiddleware(thunk)
		)

	)
	let persistor = persistStore(store)
	return { store, persistor }
}



// WEBPACK FOOTER //
// ./src/store/store.js